import Echo from "laravel-echo"
import {Config} from '~/config';
import * as types from './constants';
window.Pusher = require("pusher-js");

class Socket {
    /** @type Echo */
    socket = null;

    connect = (user, store) => {
        if (this.socket !== null) {
            this.disconnect(store);
        }
        this.socket = new Echo({
            broadcaster: "pusher",
            wsPort: 6001,
            wsHost: window.location.hostname,
            forceTLS: Config.params.FORCE_WSS,
            wssPort: 6001,
            wssHost: window.location.hostname,
            disableStats: true,
            authEndpoint: window.location.origin + "/broadcasting/auth",
            key: Config.params.APP_NAME,
            enabledTransports: ["wss", "ws"],
            auth: {
                headers: {
                    Authorization: `Bearer ${user.api_token}`,
                },
            },
        });

        this.bindChannels(store);
        this.bindTechnicalEvents(store);
    };

    bindChannels = (store) => {
        let state = store.getState();
        if (state.context.user) {
            this.socket.private(`App.Models.User.${state.context.user.id}`)
                .notification((notification) => {
                    let { type, socket, ...data } = notification;
                    store.dispatch({
                        type: 'ws:' + type,
                        data
                    });
                });
            this.socket.private(`App.Models.Company.${state.context.user.company_id}`)
                .notification((notification) => {
                    let { type, socket, ...data } = notification;
                    store.dispatch({
                        type: 'ws:' + type,
                        data
                    });
                });
        }
    };

    bindTechnicalEvents = (store) => {
        this.socket.connector.pusher.connection.bind("connecting", () => {
            store.dispatch({
                type: types.SOCKET_CONNECTING,
            });
        });
        this.socket.connector.pusher.connection.bind("connected", () => {
            store.dispatch({
                type: types.SOCKET_CONNECTED,
            });
        });
        this.socket.connector.pusher.connection.bind("disconnected", () => {
            store.dispatch({
                type: types.SOCKET_DISCONNECTED,
            });
        });
        this.socket.connector.pusher.connection.bind("unavailable", () => {
            store.dispatch({
                type: types.SOCKET_DISCONNECTED,
            });
        });
        this.socket.connector.pusher.connection.bind("error", (error) => {
            console.error(error);
        });
    }

    disconnect = (store) => {
        if (this.socket !== null) {
            this.socket.disconnect();
        }
    };
}

export default new Socket();
